/* groundlab-explain.js — the explanatory diagram for the GroundLab Crate page.

   One picture of the whole pipeline: what is on your drive, what the app does
   to it, and where it ends up in your song. Drawn in the app's own palette
   (Source/UI/Theme.h) so it reads as the product, not as stock artwork.

   It takes its three labels from the page's own step headings rather than
   carrying its own text. Text drawn here would be invisible to Shopify's
   translation system and would stay English on /fr/; borrowing the headings
   means the diagram speaks whatever language the page is in.

   Self-contained: it injects its own styles, so the theme only loads one file. */
(function () {
  'use strict';

  var root = document.querySelector('.section-groundlab');
  if (!root) return;

  var steps = root.querySelector('.gl-grid--steps');
  if (!steps) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Borrow the step headings so the diagram is translated for free. */
  var titles = [].slice.call(steps.querySelectorAll('.gl-step h3, .gl-step h2, .gl-step .gl-h3'))
    .map(function (el) { return el.textContent.trim(); });
  while (titles.length < 3) titles.push('');

  var css = [
    '.gl-flow{margin:46px 0 0;padding:0;position:relative}',
    '.gl-flow svg{display:block;width:100%;height:auto;overflow:visible}',
    '.gl-flow .fl-label{font-family:"Segoe UI",system-ui,sans-serif;font-size:13px;font-weight:600;fill:#f1f1f6}',
    '.gl-flow .fl-sub{font-family:"Segoe UI",system-ui,sans-serif;font-size:11px;fill:#a3a3b2}',
    '.gl-flow .fl-panel{fill:url(#flCard);stroke:#2c2c37}',
    '.gl-flow .fl-rail{stroke:url(#flRail);stroke-width:2;fill:none;opacity:.55}',
    '.gl-flow .fl-dot{fill:#ff6a3d}',
    '.gl-flow .fl-dot--b{fill:#ff3d77}',
    '@keyframes flRun{from{offset-distance:0%;opacity:0}' +
      '12%{opacity:1}88%{opacity:1}to{offset-distance:100%;opacity:0}}',
    '.gl-flow .fl-run{offset-path:path("M 236 150 L 392 150");animation:flRun 2.6s linear infinite}',
    '.gl-flow .fl-run2{offset-path:path("M 612 150 L 764 150");animation:flRun 2.6s linear infinite}',
    '@keyframes flSweep{0%{transform:translateX(0);opacity:0}' +
      '10%{opacity:.9}90%{opacity:.9}100%{transform:translateX(150px);opacity:0}}',
    '.gl-flow .fl-sweep{animation:flSweep 3.2s ease-in-out infinite}',
    '@keyframes flTag{0%,18%{opacity:0;transform:translateY(5px)}32%,86%{opacity:1;transform:none}100%{opacity:0;transform:translateY(-4px)}}',
    '.gl-flow .fl-tag{animation:flTag 3.2s ease-in-out infinite}',
    '.gl-flow .fl-tag--2{animation-delay:.35s}',
    '@keyframes flBar{0%,100%{transform:scaleY(.35)}50%{transform:scaleY(1)}}',
    '.gl-flow .fl-bar{transform-origin:center;animation:flBar 1.1s ease-in-out infinite}',
    '@media (prefers-reduced-motion: reduce){.gl-flow *{animation:none !important}}',
    '@media (max-width:760px){.gl-flow .fl-sub{display:none}}'
  ].join('');

  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* Bars for the "it listens" panel — fixed heights, staggered. */
  var bars = '';
  var hs = [14, 24, 9, 30, 18, 26, 12, 21];
  for (var i = 0; i < hs.length; i++) {
    bars += '<rect class="fl-bar" x="' + (470 + i * 11) + '" y="' + (150 - hs[i] / 2) +
      '" width="6" height="' + hs[i] + '" rx="3" fill="#22c3ee" opacity=".85" ' +
      'style="animation-delay:' + (i * 0.09).toFixed(2) + 's"/>';
  }

  /* Files on the left: a small stack, the raw material. */
  var files = '';
  for (var f = 0; f < 4; f++) {
    files += '<rect x="' + (96 + f * 7) + '" y="' + (112 + f * 9) + '" width="74" height="22" rx="5" ' +
      'fill="url(#flCard)" stroke="#2c2c37"/>';
  }

  var svg =
    '<svg viewBox="0 0 1000 300" role="img" aria-label="' +
      esc(titles.filter(Boolean).join(' → ')) + '">' +
    '<defs>' +
      '<linearGradient id="flCard" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="#23232c"/><stop offset="1" stop-color="#17171e"/></linearGradient>' +
      '<linearGradient id="flRail" x1="0" y1="0" x2="1" y2="0">' +
        '<stop offset="0" stop-color="#ff6a3d"/><stop offset="1" stop-color="#ff3d77"/></linearGradient>' +
      '<linearGradient id="flSweepG" x1="0" y1="0" x2="1" y2="0">' +
        '<stop offset="0" stop-color="#ff6a3d" stop-opacity="0"/>' +
        '<stop offset=".5" stop-color="#ff6a3d" stop-opacity=".55"/>' +
        '<stop offset="1" stop-color="#ff6a3d" stop-opacity="0"/></linearGradient>' +
    '</defs>' +
    '<g>' + files +
      '<text class="fl-label" x="133" y="196" text-anchor="middle">' + esc(titles[0]) + '</text>' +
    '</g>' +
    '<path class="fl-rail" d="M 236 150 L 392 150"/>' +
    '<circle class="fl-dot fl-run" r="3.5"/>' +
    '<circle class="fl-dot fl-run" r="3.5" style="animation-delay:.87s"/>' +
    '<circle class="fl-dot fl-run" r="3.5" style="animation-delay:1.74s"/>' +
    '<g>' +
      '<rect class="fl-panel" x="392" y="86" width="220" height="128" rx="14"/>' +
      '<rect class="fl-sweep" x="400" y="94" width="26" height="112" rx="8" fill="url(#flSweepG)"/>' +
      bars +
      '<g class="fl-tag">' +
        '<rect x="404" y="178" width="62" height="20" rx="10" fill="#0c0c10" stroke="#ff6a3d" opacity=".9"/>' +
        '<text class="fl-sub" x="435" y="192" text-anchor="middle" fill="#ff6a3d">128 BPM</text>' +
      '</g>' +
      '<g class="fl-tag fl-tag--2">' +
        '<rect x="474" y="178" width="60" height="20" rx="10" fill="#0c0c10" stroke="#22c3ee" opacity=".9"/>' +
        '<text class="fl-sub" x="504" y="192" text-anchor="middle" fill="#22c3ee">F minor</text>' +
      '</g>' +
      '<text class="fl-label" x="502" y="248" text-anchor="middle">' + esc(titles[1]) + '</text>' +
    '</g>' +
    '<path class="fl-rail" d="M 612 150 L 764 150"/>' +
    '<circle class="fl-dot fl-run2 fl-dot--b" r="3.5"/>' +
    '<circle class="fl-dot fl-run2 fl-dot--b" r="3.5" style="animation-delay:.87s"/>' +
    '<circle class="fl-dot fl-run2 fl-dot--b" r="3.5" style="animation-delay:1.74s"/>' +
    '<g>' +
      '<rect class="fl-panel" x="764" y="104" width="150" height="92" rx="12"/>' +
      '<rect x="776" y="116" width="126" height="20" rx="6" fill="#1f1f27" stroke="#2c2c37"/>' +
      '<rect x="776" y="142" width="126" height="20" rx="6" fill="#1f1f27" stroke="#2c2c37"/>' +
      '<rect x="776" y="142" width="126" height="20" rx="6" fill="url(#flRail)" opacity=".30"/>' +
      '<rect x="776" y="168" width="126" height="16" rx="6" fill="#15151b" stroke="#2c2c37"/>' +
      '<text class="fl-label" x="839" y="230" text-anchor="middle">' + esc(titles[2]) + '</text>' +
    '</g>' +
    '</svg>';

  var fig = document.createElement('figure');
  fig.className = 'gl-flow';
  fig.innerHTML = svg;
  steps.parentNode.insertBefore(fig, steps.nextSibling);

  if (reduced) return;
})();
